import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import signIn from "@insite/client-framework/Store/Context/Handlers/SignIn";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { CustomReportIssueFormModel } from "@tCooneyBrothers/ApiModels";
import addCustomReportIssueFormFields from "@tCooneyBrothers/Handlers/CustomReportIssueFormHandler";
import parse from "html-react-parser";
import * as React from "react";
import ChangeEvent from "react";
import { css } from "styled-components";

import {
    customReportIssueValidatorConfig,
    FormErrorsStateType,
    intialErrorFormState,
    ValidatorConfigType,
} from "@tCooneyBrothers/Components/CustomReportIssueFormValidatorConfig";

import { CallbackType, ErrorObjectType, InputObjectType, validate } from "@tCooneyBrothers/Common/Utilities/validate";

import { connect, ResolveThunks } from "react-redux";

// import Tooltip from "@insite/mobius/Tooltip";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import clearForm from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/ClearForm";
import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import { AvailabilityDto } from "@insite/client-framework/Types/ApiModels";
import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import loadUserDetails from "@tCooneyBrothers/Handlers/LoadUserDetails";
import CustomApplicationState from "@tCooneyBrothers/Store/CustomApplicationState";

export interface CustomReportIssueFormStyles {
    wrapper?: InjectableCss;
    userGridItem?: GridItemProps;
    emailTextField?: TextFieldPresentationProps;
    userNameTextField?: TextFieldPresentationProps;
    submitButton?: ButtonPresentationProps;
    formWrapper?: InjectableCss;
    customInputCss?: InjectableCss;
    fullWidth?: InjectableCss;
    inlineBlock?: InjectableCss;
    customBlockCss?: InjectableCss;
    serverError?: InjectableCss;
    textArea?: TextAreaProps;
    paddingBottom?: InjectableCss;
    callOrSms?: InjectableCss;
    text?: InjectableCss;
    availabilityMsg?: InjectableCss;
    leadTime?: InjectableCss;
    largeFont?: InjectableCss;
    alignButton?: InjectableCss;
    successModal?: ModalPresentationProps;
    modalContainer?: GridContainerProps;
    messageTextGridItem?: GridItemProps;
    buttonGridItem?: GridItemProps;
    continueButton?: ButtonPresentationProps;
    messageText?: TypographyPresentationProps;
    message?: TypographyPresentationProps;
    successMsgImage?: InjectableCss;
}

export const CustomReportIssueFormStyles: CustomReportIssueFormStyles = {
    wrapper: {
        css: css`
            font-style: normal;
        `,
    },
    userGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding-left: 100px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    serverError: {
        css: css`
            color: #1a3065;
            font-weight: 600;
            padding: 10px;
            width: 100%;
            background-color: #ff9832;
        `,
    },
    formWrapper: {
        css: css`
            // margin-top: 20px;
            // margin-bottom: 20px;
            hr {
                color: #ccc;
            }
            > div[class^="GridWrapper"] {
                margin-top: 10px;
                padding-left: 0;
                margin-bottom: 30px;
                > div[class^="GridOffset"] {
                    width: 100%;
                    margin: 0;
                }
                > div[class^="RadioStyle"] {
                    margin-top: 0;
                    border: 1px solid red;
                }
            }
            > hr {
                border-top: 2px solid #fff;
            }
        `,
    },
    customInputCss: {
        css: css`
            width: 100%;
            display: inline-block;
            vertical-align: top;
            margin-bottom: 10px;
            margin-right: 30px;
            &:nth-child(3n + 1) {
                margin-right: 0;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                            margin-right: 0;
                        `,
                    ],
                    "max",
                )}

            > div[class^="FormFieldStyle"] {
                position: relative;
                width: 100%;
                > label {
                    font-size: 13px;
                    position: absolute;
                    z-index: 1;
                    padding-left: 5px;
                    display: inline-block;
                    width: auto;
                    left: 20px;
                    background-color: #fff;
                    min-height: auto;
                }
                > div input {
                    font-size: 13px;
                    boorder: 1px solid #fff;
                }

                > div textarea {
                    font-size: 14px;
                    line-height: 18px;
                    height: 80px;
                    resize: none;
                    &::placeholder {
                        /* Chrome, Firefox, Opera, Safari 10.1+ */
                        color: #999;
                        font-style: italic;
                    }

                    &:-ms-input-placeholder {
                        /* Internet Explorer 10-11 */
                        color: #999;
                        font-style: italic;
                    }

                    &::-ms-input-placeholder {
                        /* Microsoft Edge */
                        color: #999;
                        font-style: italic;
                    }
                }
                > div select {
                    font-size: 13px;
                }
                > div[class^="FormInputWrapper"] {
                    > input {
                        font-size: 13px;
                    }
                    > div {
                        > span {
                            font-size: 13px;
                        }
                    }
                }
            }
            > div[class^="TooltipWrapper"] {
                width: 10%;
                padding: 10px;
            }
        `,
    },
    fullWidth: {
        css: css`
            width: 100%;
            > div[class^="RadioGroupStyle"] {
                justify-content: flex-start;
                display: inline-block;
                > div[class^="RadioStyle"] {
                    margin-top: 0;
                    margin-right: 20px;
                    display: inline-block;
                    &:last-child {
                        margin-rigte: 0;
                    }
                }
            }
        `,
    },
    paddingBottom: {
        css: css`
            padding-bottom: 10px;
        `,
    },
    callOrSms: {
        css: css`
            font-size: 20px;
            line-height: 26px;
            font-weight: 600;
            text-align: center;
        `,
    },
    text: {
        css: css`
            font-size: 20px;
            line-height: 26px;
            font-weight: 600;
            text-align: center;
        `,
    },
    availabilityMsg: {
        css: css`
            font-style: italic;
            font-size: 14px;
            padding-top: 10px;
            text-align: center;
        `,
    },
    leadTime: {
        css: css`
            font-size: 20px;
            line-height: 26px;
            text-align: center;
            padding-top: 10px;
            font-style: initial;
        `,
    },
    largeFont: {
        css: css`
            font-size: 20px;
            line-height: 26px;
            text-align: center;
        `,
    },
    alignButton: {
        css: css`
            text-align: center;
        `,
    },
    successModal: {
        sizeVariant: "small",
    },
    messageTextGridItem: { width: 12 },
    messageText: {
        css: css`
            display: flex;
            align-items: flex-start;
        `,
    },
    message: {
        css: css`
            padding-left: 8px;
        `,
    },
    buttonGridItem: {
        width: 12,
        css: css`
            justify-content: flex-end;
        `,
    },
    successMsgImage: {
        css: css`
            background: url(/UserFiles/Images/Icons/checkedmark.png) no-repeat 0 0;
            padding: 7px 0 20px 30px;
            color: #193066;
            font-size: 13px;
            font-weight: bold;
            // margin-top: 15px;
            background-size: 24px;
        `,
    },
};
const StyledSpan = getStyledWrapper("span");

const mapDispatchToProps = {
    addCustomReportIssueFormFields,
    loadUserDetails,
};

interface OwnProps {
    extendedStyles?: CustomReportIssueFormStyles;
    parentModalState?: any;
}

const mapStateToProps = (state: CustomApplicationState) => {
    return {
        sessionData: state.context?.session,
        userDatails: state.cbData.userDetails.value,
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const emailRequiredFieldMessage = siteMessage("CreateNewAccountInfo_EmailAddress_Required");
const emailFieldMessage = siteMessage("CreateNewAccountInfo_EmailAddress_ValidEmail");
const emailRegexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");

const CustomReportIssueForm: React.FunctionComponent<Props> = function Account(props: Props) {
    const [styles] = React.useState(() => mergeToNew(CustomReportIssueFormStyles, props.extendedStyles));
    const [email, setEmail] = React.useState("");
    const [isSubmitted, setIsSubmitted] = React.useState(false);
    const [emailError, setEmailError] = React.useState(emailRequiredFieldMessage);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [firstName, setFirstName] = React.useState("");
    const [company, setCompany] = React.useState("");
    const [comments, setComments] = React.useState("");
    const [isButtonDisabled, setIsButtonDisabled] = React.useState(true);
    const [formErrors, setFormErrors] = React.useState<FormErrorsStateType>(intialErrorFormState);
    const toasterContext = React.useContext(ToasterContext);
    const [isModalOpen, setIsModalOpen] = React.useState(false);

    React.useEffect(() => {
        if (!props.sessionData.isGuest && props.sessionData.isAuthenticated) {
            const firstName = props.sessionData.firstName;
            const lastName = props.sessionData.lastName;
            setFirstName(`${firstName} ${lastName}`);
            setEmail(props.sessionData.email);
            props.loadUserDetails();
        }
    }, []);

    React.useEffect(() => {
        if (props.sessionData.isAuthenticated && props.userDatails && props.userDatails.length > 0) {
            setCompany(props.userDatails[0].companyName);
        }
    }, [props.userDatails]);

    React.useEffect(() => {
        const firstNameSelector: HTMLInputElement | null = document.querySelector('[name="firstName"]');
        if (props.sessionData.isAuthenticated && firstNameSelector) {
            validateHandler(firstNameSelector);
        }
    }, [firstName]);

    React.useEffect(() => {
        const emailSelector: HTMLInputElement | null = document.querySelector('[name="email"]');
        if (props.sessionData.isAuthenticated && emailSelector) {
            validateEmail(emailSelector.value);
            validateHandler(emailSelector);
        }
    }, [email]);

    const validateEmail = (email: string) => {
        const errorMessage = !email ? emailRequiredFieldMessage : emailRegexp.test(email) ? "" : emailFieldMessage;
        setEmailError(errorMessage);
        return !errorMessage;
    };

    const emailChangeHandler = (input: HTMLInputElement) => {
        validateEmail(input.value);
        setEmail(input.value);
        validateHandler(input);
    };

    const submitHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (!isSubmitted) {
            setIsSubmitted(true);
        }
        const addCpn: CustomReportIssueFormModel = {
            url: window.location.href,
            firstName,
            emailAddress: email,
            company,
            comments,
            type: "ReportIssue"
        };
        props.addCustomReportIssueFormFields(addCpn);
        setIsModalOpen(true);
        clearForm();
    };

    const onSuccessHandler = () => {
        setErrorMessage("");
        toasterContext.addToast({
            body: translate("Account created successfully!"),
            messageType: "success",
        });
    };

    const firstNameChangeHandler = (input: HTMLInputElement) => {
        setFirstName(input.value);
        validateHandler(input);
    };

    const companyChangeHandler = (input: HTMLInputElement) => {
        setCompany(input.value);
        // validateHandler(input);
    };

    const commentsChangeHandler = (input: HTMLTextAreaElement) => {
        setComments(input.value);
        validateHandler(input);
    };

    const validateSubmitDisabled = (errorsState: FormErrorsStateType) => {
        return Object.keys(errorsState).length !== 0;
    };

    const validateHandler = (
        input: HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement,
        customValidation?: CallbackType,
    ): void => {
        const inputObject: InputObjectType = {
            name: input.name,
            value: input.value,
        };
        const validatorConfig = customReportIssueValidatorConfig[input.name as keyof ValidatorConfigType];
        const isValidate: ErrorObjectType | undefined = validate(inputObject, validatorConfig, customValidation);

        if (isValidate === undefined) {
            delete formErrors[input.name as keyof FormErrorsStateType];
            setFormErrors(formErrors);
        } else {
            setFormErrors({
                ...formErrors,
                [input.name]: isValidate ? isValidate.errorMsg : isValidate,
            });
        }
        if (!validatorConfig.required && input.value === "") {
            delete formErrors[input.name as keyof FormErrorsStateType];
            setFormErrors(formErrors);
        }
        setIsButtonDisabled(validateSubmitDisabled(formErrors));
    };

    React.useEffect(() => {
        setIsButtonDisabled(validateSubmitDisabled(formErrors));
    }, [formErrors]);

    const continueButtonClickHandler = () => {
        setIsModalOpen(false);
        props.parentModalState(false);
        clearForm();
        window.location.reload();
        window.scrollTo(0, 0);
        let divTarget = document.querySelector<HTMLElement>('[data-test-selector="unhandledErrorModal"]');
        if(divTarget) {
            let parentModal = divTarget.closest<HTMLElement>('[class^="Scrim"]');
            if(parentModal) {
                parentModal.style.display = 'none';
            }
        }
    };

    return (
        <StyledWrapper {...styles.formWrapper}>
            <StyledWrapper {...styles.fullWidth}>
                <Typography as="p" {...styles.largeFont}>
                    {siteMessage("ReportAnIssueDescription")}
                </Typography>
                <hr />
                <StyledWrapper {...styles.customInputCss}>
                    <TextField
                        {...styles.userNameTextField}
                        label={translate("Name")}
                        value={firstName}
                        data-test-selector="createAccount_firstName"
                        onChange={e => firstNameChangeHandler(e.currentTarget)}
                        onBlur={e => validateHandler(e.currentTarget)}
                        error={!!formErrors.firstName && formErrors.firstName}
                        name="firstName"
                        iconProps={{ color: "danger", src: formErrors.firstName ? AlertTriangle : undefined }}
                        required
                    />
                </StyledWrapper>
                <StyledWrapper {...styles.customInputCss}>
                    <TextField
                        {...styles.emailTextField}
                        type="email"
                        label={translate("Email Address")}
                        onChange={e => emailChangeHandler(e.currentTarget)}
                        value={email}
                        data-test-selector="createAccount_email"
                        required
                        onBlur={e => validateHandler(e.currentTarget)}
                        error={!!formErrors.email && formErrors.email}
                        name="email"
                        iconProps={{ color: "danger", src: formErrors.email ? AlertTriangle : undefined }}
                    />
                </StyledWrapper>
                <StyledWrapper {...styles.customInputCss}>
                    <TextField
                        {...styles.userNameTextField}
                        label={translate("Company")}
                        value={company}
                        data-test-selector="createAccount_firstName"
                        onChange={e => companyChangeHandler(e.currentTarget)}
                        // onBlur={e => validateHandler(e.currentTarget)}
                        // error={!!formErrors.company && formErrors.company}
                        name="company"
                        // iconProps={{ color: "danger", src: formErrors.company ? AlertTriangle : undefined }}
                    />
                </StyledWrapper>
                <StyledWrapper {...styles.customInputCss}>
                    <TextArea
                        {...styles.textArea}
                        label={translate("Comments")}
                        value={comments}
                        data-test-selector="createAccount_firstName"
                        onChange={e => commentsChangeHandler(e.currentTarget)}
                        error={!!formErrors.coments && formErrors.coments}
                        name="comments"
                        placeholder="Please provide quantity, specific delivery date if needed, and any other requirements you have."
                        // eslint-disable-next-line no-return-assign
                        onFocus={e => (e.target.placeholder = "")}
                        // eslint-disable-next-line no-return-assign
                        onBlur={e =>
                            (e.target.placeholder =
                                "Please provide quantity, specific delivery date if needed, and any other requirements you have.")
                        }
                        required
                    />
                </StyledWrapper>
            </StyledWrapper>
            <StyledWrapper {...styles.alignButton}>
                <Button
                    {...styles.submitButton}
                    onClick={submitHandler}
                    disabled={isButtonDisabled}
                    data-test-selector="createAccount_createButton"
                >
                    {translate("Submit")}
                </Button>
            </StyledWrapper>
            <Modal
                headline={translate("Thank You")}
                contentLabel="Confirm"
                {...styles.successModal}
                isOpen={isModalOpen}
                handleClose={continueButtonClickHandler}
            >
                <GridContainer {...styles.modalContainer}>
                    <GridItem {...styles.messageTextGridItem}>
                        <Typography {...styles.messageText}>
                            <StyledSpan {...styles.successMsgImage}></StyledSpan>
                            <StyledSpan {...styles.message}>
                                {translate(
                                    "Your request is being processed and we will be in contact with you shortly.",
                                )}
                            </StyledSpan>
                        </Typography>
                    </GridItem>
                    <GridItem {...styles.buttonGridItem}>
                        <Button {...styles.continueButton} onClick={continueButtonClickHandler}>
                            {translate("OK")}
                        </Button>
                    </GridItem>
                </GridContainer>
            </Modal>
        </StyledWrapper>
    );
};
export default connect(mapStateToProps, mapDispatchToProps)(CustomReportIssueForm);
